import { useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import { CardListItem } from "../CardListItem";
import { useCardList } from "./hooks/useCardList";
import styles from "./styles.module.scss";

export const CardList = () => {
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "CardList");

  const {
    context: { cards, cardLimit, hasMoreCards },
    handlers: { onShowMoreCards, onDeleteClick },
  } = useCardList();

  return (
    <div className={cn("card-container")}>
      {cards.map((card, index) =>
        index < cardLimit ? (
          <CardListItem key={card.id} {...card} onDeleteClick={onDeleteClick} />
        ) : null
      )}

      {hasMoreCards && (
        <button className={cn("view-all-cards")} onClick={onShowMoreCards}>
          {t("wallet.cards.showMoreCards")}
        </button>
      )}
    </div>
  );
};
